import script from "./UpdateRateGroupModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateRateGroupModal.vue?vue&type=script&setup=true&lang=js"

import "./UpdateRateGroupModal.vue?vue&type=style&index=0&id=3575074f&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3575074f"]])

export default __exports__